import { render, staticRenderFns } from "./Pointers.vue?vue&type=template&id=fc2f0690"
import script from "./Pointers.vue?vue&type=script&lang=js"
export * from "./Pointers.vue?vue&type=script&lang=js"
import style0 from "./Pointers.vue?vue&type=style&index=0&id=fc2f0690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports